import { useState } from 'react';
import { Input } from 'reactstrap';
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  eyeDisabled?: boolean;
  forceShowPass?: boolean;
}

export const InputPassword: React.FC<InputProps> = ({ eyeDisabled, forceShowPass = false, ...rest }) => {
  const [show, setShow] = useState<boolean>(forceShowPass);
  const handleShowPass = () => setShow(!show);
  return (
    <div className={`${rest?.className || ''} gm-eye-input-container`}>
      <Input {...rest} type={show ? 'text' : 'password'} />
      <button type='button' onClick={handleShowPass} disabled={eyeDisabled}>
        {show ? <BsEyeSlashFill size={16} /> : <BsEyeFill size={16} />}
      </button>
    </div>
  )
};